<template>
	<div class="text-center">
		<h1 class="text-h4 font-weight-bold">Server Unreachable</h1>
		<p class="mb-0">The server seems offline.</p>
		<p class="mb-0">We will automatically refresh the page when the servers are back online.</p>
	</div>
</template>

<script lang="ts">
import { mdiServerOff } from "@mdi/js";
import { useHTTP } from "@soft-db/http/vue";
import { defineComponent, onUnmounted } from "vue";

export default defineComponent({
	name: "ServerError",
	layout: "empty-state",
	data: () => ({
		mdiServerOff,
	}),
	setup() {
		const http = useHTTP();

		const refreshInterval = setInterval(async () => {
			const health = await http.get("/health");
			if (health.status === "SUCCESS") {
				location.href = "/";
			}
		}, 10_000);

		onUnmounted(() => {
			clearInterval(refreshInterval);
		});

		return {};
	},
});
</script>
